// removed by extract-text-webpack-plugin
module.exports = {"tabLabel":"_3IaUrBhrfl1NxaVvmeRdGt","root":"_2g8OZqHJTHL2_f10P7mCXb","headerMenu":"_1wP74HPA8zKlt7Uic2WcXv","mainMenu":"_2IgD4y9JP4hEdHy9E6JMRt","menuTabActive":"_7jCyaTrVDoCcmBCdhbC0a","menuTab":"_2BueKAucJgdUbrhNuJAs04","menuStyle":"_2QwhP3pGSurdpi2CSy9inA","menuTabWrapper":"AccG1y2hOC3Eq3vfSGnHB","configMenuIcon":"_1i07HT-1S8cfJk8Cc4zeaB","configMenuIconInvert":"_2-Ix2EfwWT3DNkP5iGLudW _1i07HT-1S8cfJk8Cc4zeaB","configMenu":"_31STilhrVPi8m4avOzXvEu","configButtonText":"j5WM6K-f0QIRrec1KSXgu"};


//////////////////
// WEBPACK FOOTER
// ./src/views/App/TopMenu/styles.css
// module id = 1081
// module chunks = 0